import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const kustoTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.kusto.datasetType,
    displayName: stringResources.Kusto_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.kusto.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-azure_kusto'
    },
    isFirstClass: true,
    notSupportPreviewData: true,
    notSupportImportSchema: true,
    notSupportLookupActivity: true,
    disableTableName: true,
    category: ['ServicesApps'],
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'database',
                required: true,
                label: stringResources.Database
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textarea',
                bind: 'readerQuery', // this is UI property name, instead of payload property name
                label: stringResources.QueryLabel,
                required: true
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ]
};
